import { wrapPromise } from 'persist-promise/wrapPromise';
const ASSOCIATIONS_TRACKING_KEY = 'Associations';
export const toCacheKey = (fromObjectTypeId, fromObjectId, toObjectTypeId, cardId) => `${fromObjectTypeId}/${fromObjectId}/${toObjectTypeId}/${cardId}`;
export const convertKeyToMetricsDimension = key => {
  const objectTypeId = key.split('/')[2];
  if (objectTypeId.startsWith('2-')) {
    return 'customObject';
  }
  return objectTypeId;
};
export const normalizeForPatchDiffingAssociationChanges = data => {
  if (!data || !data.results) {
    return [];
  }
  const associations = data.results.map(result => {
    const properties = result.properties ? Object.fromEntries(result.properties.map(({
      name,
      value
    }) => [name, value])) : null;
    return {
      [result.id]: properties
    };
  });
  return associations;
};
export const trackAssociatedObjectsChangesClient = wrapPromise({
  namespace: 'Records',
  entityName: ASSOCIATIONS_TRACKING_KEY,
  toCacheKey,
  fetch: (_fromObjectTypeId, _fromObjectId, _toObjectTypeId, _cardId, data) => Promise.resolve(data),
  metricsConfig: {
    enablePatchDiffing: true,
    convertKeyToMetricsDimension,
    normalizeForPatchDiffing: normalizeForPatchDiffingAssociationChanges
  }
});